import { render, staticRenderFns } from "./ReclamoInicio.html?vue&type=template&id=76653a0b&external"
import script from "./ReclamoInicio.vue?vue&type=script&lang=js"
export * from "./ReclamoInicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports